export default {
  fields: {
    demo: {
      label: 'Demo aanmaken',
    },
    ai: {
      label: 'AI-geoptimaliseerd',
    },
    restaurant_type: {
      label: 'Selecteer restauranttype',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizzabezorging 🍕🚗',
        PizzaNeapolitan: 'Napolitaanse pizza 🍕',
        Italian: 'Italiaans 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Turks 🇹🇷',
        Mexican: 'Mexicaans 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japans 🇯🇵',
        Vietnamese: 'Vietnamees 🇻🇳',
        Thai: 'Thais 🇹🇭',
        Asian: 'Aziatisch 🍜',
        Indian: 'Indiaas 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegan 🥑',
        Greek: 'Grieks 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Oriëntaals / Midden-Oosters 🧆',
        Spanish: 'Spaans / Tapas 🇪🇸',
        Persian: 'Perzisch 🫖',
      },
    },
    plugins: {
      reservations: 'Reserveringen',
      reservations_plan_hint:
        'Reserveringen vereisen een Partnerplan. U wordt gevraagd dit te activeren voor {{name}} wanneer u de website aanmaakt.',
      catering: 'Catering',
      events: 'Evenementen',
    },
    quarter: {
      label: 'Wijk',
      address_placeholder: 'Adres invoeren',
      quarter_placeholder: 'Wijk invoeren',
    },
    delivery_areas: {
      label: 'Welke gebieden bedient u in de stad?',
      city_placeholder: 'Stad invoeren',
      district_placeholder: 'Wijk 1, Wijk 2, Wijk 3',
    },
    best_dishes: {
      label: 'Wat zijn uw top 3 gerechten?',
      placeholder: 'Gerechten invoeren (Kipburger, Cheeseburger, enz.)',
    },
    dietary_attributes: {
      label: 'Heeft u opties voor mensen die willen eten:',
      placeholder: 'Selecteer dieetkenmerken',
      types: {
        vegetarian: 'Vegetarisch',
        vegan: 'Vegan',
        halal: 'Halal',
        gluten_free: 'Glutenvrij',
        dairy_free: 'Zuivelvrij',
        spicy: 'Pittig',
      },
    },
    family_owned: {
      label: 'Familiebedrijf?',
      yes: 'Ja',
      no: 'Nee',
    },
    business_founding_year: {
      label: 'Wanneer is het restaurant gestart (welk jaar)?',
    },
    business_owners: {
      label: 'Eigenaren',
      placeholder: 'Eigenaar invoeren',
    },
    notes: {
      label: 'Aanvullende notities toevoegen (optioneel)',
      placeholder: 'Bijv. gemeenschapsgericht restaurant, initiatieven, paar als eigenaar...',
    },
    about_us: {
      title: 'Over ons (Voorbeeld)',
    },
  },
  sections: {
    plugins: 'Plugins',
    company_info: 'Bedrijfsinfo genereren',
  },
  buttons: {
    find_district: 'Wijk zoeken',
    generate: 'Genereren',
    products: 'Producten',
    add: 'Toevoegen',
  },
};
